import { render, staticRenderFns } from "./shutdown-banner.vue?vue&type=template&id=f919d8b6&scoped=true"
import script from "./shutdown-banner.vue?vue&type=script&lang=js"
export * from "./shutdown-banner.vue?vue&type=script&lang=js"
import style0 from "./shutdown-banner.vue?vue&type=style&index=0&id=f919d8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f919d8b6",
  null
  
)

export default component.exports